import { z } from 'zod';

export const ReportPeriod = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  CUSTOM: 'CUSTOM',
} as const;
export type ReportPeriod = (typeof ReportPeriod)[keyof typeof ReportPeriod];

export const generateReportSchema = z.object({
  clientId: z.string().uuid(),
  period: z.nativeEnum(ReportPeriod),
  from: z.coerce.date(),
  to: z.coerce.date(),
  includeAiCommentary: z.boolean().default(true),
  includeCreativePreviews: z.boolean().default(true),
  includeFunnel: z.boolean().default(true),
  /** Se definido, o link público exige senha. */
  publicLinkPassword: z.string().min(6).max(64).optional(),
  recipients: z.array(z.string().email()).max(20).default([]),
});
export type GenerateReportInput = z.infer<typeof generateReportSchema>;

/** Comentário analítico produzido pela IA sobre números já calculados. */
export const reportCommentarySchema = z.object({
  headline: z.string().max(200),
  summary: z.string().max(2000),
  highlights: z.array(z.string().max(300)).max(6),
  concerns: z.array(z.string().max(300)).max(6),
  nextSteps: z.array(z.string().max(300)).max(6),
});
export type ReportCommentary = z.infer<typeof reportCommentarySchema>;

export interface AgencyDashboard {
  totalSpendCents: number;
  previousSpendCents: number;
  activeClients: number;
  totalLeads: number;
  averageCplCents: number;
  clientsWithoutConversions: { clientId: string; clientName: string; spendCents: number }[];
  budgetLimitedCampaigns: { campaignId: string; name: string; clientName: string }[];
  disapprovedAds: { adId: string; name: string; clientName: string; reason: string }[];
  performanceDrops: { clientId: string; clientName: string; dropPct: number }[];
  disconnectedAccounts: { clientId: string; clientName: string; provider: string }[];
  plannedVsSpent: { clientId: string; clientName: string; plannedCents: number; spentCents: number }[];
  topClients: { clientId: string; clientName: string; spendCents: number; leads: number; cplCents: number }[];
  topCampaigns: { campaignId: string; name: string; clientName: string; leads: number; cplCents: number }[];
}

export const publicReportAccessSchema = z.object({
  token: z.string().min(20).max(120),
  password: z.string().max(64).optional(),
});
export type PublicReportAccessInput = z.infer<typeof publicReportAccessSchema>;
